// src/applyDecorators.ts
import React from "react";
import { defaultDecorateStory } from "storybook/preview-api";
var applyDecorators = (storyFn, decorators) => defaultDecorateStory((context) => React.createElement(storyFn, context), decorators);

export {
  applyDecorators
};
